import { SitesActionTypes } from './sites.types';
// LOADING
const setLoading = isLoading => ({ type: SitesActionTypes.SET_LOADING, payload: { isLoading } });
const setLoadingExclusion = isLoading => ({ type: SitesActionTypes.SET_LOADING_EXCLUSION, payload: { isLoading } });
const setLoadingTlds = isLoading => ({ type: SitesActionTypes.SET_LOADING_TLDS, payload: { isLoading } });
const setLoadingDomains = isLoading => ({ type: SitesActionTypes.SET_LOADING_DOMAINS, payload: { isLoading } });
const setLoadingPlans = isLoading => ({ type: SitesActionTypes.SET_LOADING_PLANS, payload: { isLoading } });
const setLoadingSites = isLoading => ({ type: SitesActionTypes.SET_LOADING_SITES, payload: { isLoading } });
const setLoadingSslVerification = isLoading => ({ type: SitesActionTypes.SET_LOADING_SSL_VERIFICATION, payload: { isLoading } });
const setLoadingSslDomainConfiguration = isLoading => ({ type: SitesActionTypes.POST_DOMAIN_TO_HG_LOADING, payload: { isLoading } });
const setLoadingDomainValidation = isLoading => ({ type: SitesActionTypes.SET_LOADING_DOMAIN_VALIDATION, payload: { isLoading } });

// SITES
const requestSites = () => ({ type: SitesActionTypes.REQUEST_GET_SITES });
const getSitesSuccess = () => ({ type: SitesActionTypes.GET_SITES_SUCCESS });
const getSitesFailure = () => ({ type: SitesActionTypes.GET_SITES_FAILURE });
const setSites = (sites = []) => ({ type: SitesActionTypes.SET_SITES, payload: { sites } });
const deleteSite = ({ site, setSiteInExclusion }) => ({ type: SitesActionTypes.DELETE_SITE, payload: { site, setSiteInExclusion } });
const redirectToEdit = ({
  builderAddonId,
  popupBlockedAction,
  hostingId,
  domain,
  history,
  siteBuilderUrl,
  sitesWizardUrl,
  webPresenceUrl,
  cpanelUrl,
}) => ({
  type: SitesActionTypes.REDIRECT_TO_EDIT,
  payload: {
    builderAddonId,
    popupBlockedAction,
    hostingId,
    domain,
    history,
    siteBuilderUrl,
    sitesWizardUrl,
    webPresenceUrl,
    cpanelUrl,
  },
});
const loadRedirect = domain => ({ type: SitesActionTypes.SET_LOADING_REDIRECT, payload: { domain } });

// DOMAINS
const requestDomains = (getSitesWithBuilderTools = false) => ({ type: SitesActionTypes.REQUEST_GET_DOMAINS, payload: { getSitesWithBuilderTools } });
const getDomainsSuccess = () => ({ type: SitesActionTypes.GET_DOMAINS_SUCCESS });
const getDomainsFailure = () => ({ type: SitesActionTypes.GET_DOMAINS_FAILURE });
const setDomains = (domains = []) => ({
  type: SitesActionTypes.SET_SITES_DOMAINS,
  payload: {
    domains,
  },
});

const requestSiteBuilderTools = ({ hostingId, domain, redirect }) => ({
  type: SitesActionTypes.REQUEST_SITE_BUILDER_TOOLS,
  payload: { hostingId, domain, redirect },
});
const setSiteBuilderTools = domainData => ({ type: SitesActionTypes.SET_SITE_BUILDER_TOOLS, payload: { domainData } });
const loadSiteBuilderTools = payload => ({ type: SitesActionTypes.LOAD_SITE_BUILDER_TOOLS, payload });
const getSiteBuilderTools = action => ({
  type: SitesActionTypes.REQUEST_GET_SITE_BUILDER_TOOLS,
  payload: action.payload,
});

//  TLDS
const requestTlds = () => ({ type: SitesActionTypes.REQUEST_GET_TLDS });
const getTldsFailure = () => ({ type: SitesActionTypes.GET_TLDS_FAILURE });
const getTldsSuccess = () => ({ type: SitesActionTypes.GET_TLDS_SUCCESS });
const setTlds = tlds => ({
  type: SitesActionTypes.SET_TLDS,
  payload: {
    tlds,
  },
});

// DOMAIN AVAILABILITY
const getDomainAvailabilityFailure = () => ({ type: SitesActionTypes.GET_DOMAIN_AVAILABILITY_FAILURE });
const getDomainAvailabilitySuccess = () => ({ type: SitesActionTypes.GET_DOMAIN_AVAILABILITY_SUCCESS });
const requestDomainAvailability = ({ domain }) => ({
  type: SitesActionTypes.REQUEST_GET_DOMAIN_AVAILABILITY,
  payload: { domain },
});
const setDomainAvailability = ({
  domainAvailability,
  domainTldAvailability,
  domain,
  domainAndSubdomain,
}) => ({
  type: SitesActionTypes.SET_DOMAIN_AVAILABILITY,
  payload: {
    domainAvailability, domainTldAvailability, domain, domainAndSubdomain,
  },
});


// PLANS
const requestPlans = () => ({ type: SitesActionTypes.REQUEST_GET_PLANS });
const getPlansSuccess = () => ({ type: SitesActionTypes.GET_PLANS_SUCCESS });
const getPlansFailure = () => ({ type: SitesActionTypes.GET_PLANS_FAILURE });
const setPlans = plans => ({
  type: SitesActionTypes.SET_PLANS,
  payload: {
    plans,
  },
});

// WARNINGS
const setWarningsSuccess = () => ({ type: SitesActionTypes.SET_WARNINGS_SUCCESS });
const setWarningsFailure = () => ({ type: SitesActionTypes.SET_WARNINGS_FAILURE });
const setWarningSeen = () => ({ type: SitesActionTypes.SET_WARNING_SEEN });

// SUBDOMAIN
const requestAditionalDomain = (domain, planExternalId, withAditionDomainV2 = false) => ({ type: SitesActionTypes.REQUEST_ADITIONAL_DOMAIN_TO_PLAN, payload: { domain, planExternalId, withAditionDomainV2 } });
const succeedRequestAditionalDomain = () => ({ type: SitesActionTypes.SUCCEED_ADITIONAL_DOMAIN_TO_PLAN });
const failRequestAditionalDomain = () => ({ type: SitesActionTypes.FAIL_ADITIONAL_DOMAIN_TO_PLAN });
const setAditionalDomainLinkedToPlan = payload => ({ type: SitesActionTypes.SET_ADITIONAL_DOMAIN_LINKED_TO_PLAN, payload });

// CHANGE DOMAIN DNS
const requestChangeDomainDns = (domainId, planId, selectedDomain) => ({ type: SitesActionTypes.REQUEST_CHANGE_DOMAIN_DNS, payload: { domainId, planId, selectedDomain } });
const setDomainDnsChanged = ({ domainDnsChanged }) => ({ type: SitesActionTypes.SET_DOMAIN_DNS_CHANGED, payload: { domainDnsChanged } });
const changeDomainDnsSuccess = () => ({ type: SitesActionTypes.CHANGE_DOMAIN_DNS_SUCCESS });
const changeDomainDnsFailure = () => ({ type: SitesActionTypes.CHANGE_DOMAIN_DNS_FAILURE });

// GET DOMAIN DNS
const requestDomainDns = ({
  domain,
  onDomainRegitered,
  onDomainNotRegistered,
}) => ({
  type: SitesActionTypes.REQUEST_DOMAIN_DNS,
  payload: {
    domainLabel: domain, onDomainRegitered, onDomainNotRegistered,
  },
});
const domainDnsSuccess = () => ({ type: SitesActionTypes.GET_DOMAIN_DNS_SUCCESS });
const domainDnsFailure = () => ({ type: SitesActionTypes.GET_DOMAIN_DNS_FAILURE });
const domainDnsLoading = isLoading => ({ type: SitesActionTypes.SET_DOMAIN_DNS_LOADING, payload: { isLoading } });
const resetDomainDnsStatus = () => ({ type: SitesActionTypes.RESET_DOMAIN_DNS_STATUS });
const setDomainDns = domainDns => ({
  type: SitesActionTypes.SET_DOMAIN_DNS,
  payload: {
    domainDns,
  },
});

// GET PLAN DNS
const requestPlanDns = planId => ({ type: SitesActionTypes.REQUEST_PLAN_DNS, payload: { planId } });
const planDnsSuccess = () => ({ type: SitesActionTypes.GET_PLAN_DNS_SUCCESS });
const planDnsFailure = () => ({ type: SitesActionTypes.GET_PLAN_DNS_FAILURE });
const setPlanDnsLoading = isLoading => ({ type: SitesActionTypes.SET_PLAN_DNS_LOADING, payload: { isLoading } });
const resetPlanDns = () => ({ type: SitesActionTypes.RESET_PLAN_DNS });
const setPlanDns = planDns => ({
  type: SitesActionTypes.SET_PLAN_DNS,
  payload: {
    planDns,
  },
});

// SITEBUILDER ACTIVE
const setHasSiteBuilderActive = hasSiteBuilderActive => ({
  type: SitesActionTypes.SET_SITE_BUILDER_ACTIVE,
  payload: {
    hasSiteBuilderActive,
  },
});

// WORDPRESS INSTALLATION LOADING
const requestWordpressInstallation = ({
  wordpress,
  setHgPluginIsInstall,
  isWondersuiteEnabled,
  themeId,
  userSelectedWondersuiteTrial,
  isFastCheckoutAddonEnabled,
  userSelectedUseEcommercePlus,
  requestAutoSsl,
}) => ({
  type: SitesActionTypes.REQUEST_WORDPRESS_INSTALLATION,
  payload: {
    wordpress,
    setHgPluginIsInstall,
    isWondersuiteEnabled,
    themeId,
    userSelectedWondersuiteTrial,
    isFastCheckoutAddonEnabled,
    userSelectedUseEcommercePlus,
    requestAutoSsl,
  },
});
const setWordpressInstallationSuccess = ({ ssoUrl, siteId }) => ({ type: SitesActionTypes.SET_WORDPRESS_INSTALLATION_SUCCESS, payload: { ssoUrl, siteId } });
const setWordpressInstallationFailure = () => ({ type: SitesActionTypes.SET_WORDPRESS_INSTALLATION_FAILURE });
const setWordpressInstallationStatus = installed => ({ type: SitesActionTypes.SET_WORDPRESS_INSTALLATION_STATUS, payload: { installed } });
const setWordpressInstallationLoading = isLoading => ({ type: SitesActionTypes.SET_WORDPRESS_INSTALLATION_LOADING, payload: { isLoading } });
const setWordpressInstallationToDefault = () => ({ type: SitesActionTypes.SET_WORDPRESS_INSTALLATION_DEFAULT });

// WORDPRESS MIGRATION
const requestWordpressFtpMigration = ({
  formData, domain, hostingId,
}) => ({
  type: SitesActionTypes.REQUEST_WORDPRESS_FTP_MIGRATION,
  payload: {
    formData,
    domain,
    hostingId,
  },
});
const setWordpressFtpMigrationSuccess = () => ({ type: SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_SUCCESS });
const setWordpressFtpMigrationFailure = () => ({ type: SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_FAILURE });
const setWordpressFtpMigrationLoading = isLoading => ({ type: SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_LOADING, payload: { isLoading } });
const setWordpressFtpMigrationReset = () => ({ type: SitesActionTypes.SET_WORDPRESS_FTP_MIGRATION_RESET });

const requestwordpressFilesData = ({
  hostingId, files, domain, onFinish,
}) => ({
  type: SitesActionTypes.REQUEST_WORDPRESS_FILES_DATA,
  payload: {
    hostingId,
    files,
    domain,
    onFinish,
  },
});
const requestWordpressFilesMigration = ({
  hostingId,
  domain,
  migrationId,
  session,
  path,
  serverId,
  chunks,
  index,
  hostname,
  migrationToken,
  leftTrys = 3,
  baseAttempts = 3,
  zipFile,
  sqlFile,
  onFinish,
}) => ({
  type: SitesActionTypes.REQUEST_WORDPRESS_FILES_MIGRATION,
  payload: {
    hostingId,
    domain,
    migrationId,
    session,
    path,
    serverId,
    chunks,
    index,
    hostname,
    migrationToken,
    leftTrys,
    baseAttempts,
    zipFile,
    sqlFile,
    onFinish,
  },
});
export const setWordpressFilesMigrationLoading = bool => ({
  type: SitesActionTypes.SET_WORDPRESS_FILES_MIGRATION_LOADING,
  payload: { bool },
});
export const wordpressInstallFiles = ({
  hostingId, migrationId, zipFile, sqlFile, path, onFinish,
}) => ({
  type: SitesActionTypes.WORDPRESS_INSTALL_FILES,
  payload: {
    hostingId, migrationId, zipFile, sqlFile, path, onFinish,
  },
});
export const successfullyRequestedData = () => ({ type: SitesActionTypes.WP_SUCCESSFULLY_REQUESTED_DATA });
export const successfullyRequestedMigration = () => ({ type: SitesActionTypes.WP_SUCCESSFULLY_REQUESTED_MIGRATION });
export const finishedRequestedInstallation = payload => ({ type: SitesActionTypes.WP_SUCCESSFULLY_REQUESTED_INSTALATION, payload });
export const failureRequestedData = () => ({ type: SitesActionTypes.WP_FAILURE_REQUESTED_DATA });
export const failureRequestedMigration = () => ({ type: SitesActionTypes.WP_FAILURE_REQUESTED_MIGRATION });
export const failureRequestedInstallation = () => ({ type: SitesActionTypes.WP_FAILURE_REQUESTED_INSTALLATION });

// WORDPRESS SSO
const requestWordpressSSO = ({
  hostingId, siteId, domain, callbackFunction, setBlockedWindowUrl,
}) => ({
  type: SitesActionTypes.REQUEST_WORDPRESS_SSO,
  payload: {
    hostingId, siteId, domain, callbackFunction, setBlockedWindowUrl,
  },
});
const successWordpressSSO = () => ({ type: SitesActionTypes.SET_WORDPRESS_SSO_SUCCESS });
const failureWordpressSSO = () => ({ type: SitesActionTypes.SET_WORDPRESS_SSO_FAILURE });
const setWordpressSSO = ssoUrl => ({ type: SitesActionTypes.SET_WORDPRESS_SSO, payload: { ssoUrl } });
const setWordpressSSOLoading = isLoading => ({
  type: SitesActionTypes.SET_WORDPRESS_SSO_LOADING,
  payload: { isLoading },
});

// SURVEY QUESTIONS ANSWERED
const requestSurveyQuestionsAnswered = surveyId => ({ type: SitesActionTypes.REQUEST_SURVEY_QUESTIONS_ANSWERED, payload: { surveyId } });
const surveyQuestionsAnsweredSuccess = () => ({ type: SitesActionTypes.GET_SURVEY_QUESTIONS_ANSWERED_SUCCESS });
const surveyQuestionsAnsweredFailure = () => ({ type: SitesActionTypes.GET_SURVEY_QUESTIONS_ANSWERED_FAILURE });
const setSurveyQuestionsAnswered = questions => ({
  type: SitesActionTypes.SET_SURVEY_QUESTIONS_ANSWERED,
  payload: {
    questions,
  },
});

// FORCE
const forceReload = bool => ({ type: SitesActionTypes.FORCE_RELOAD, payload: bool });

// ADDON CHECK
const requestAddonCheck = ({ hostingId }) => ({ type: SitesActionTypes.REQUEST_ADDON_CHECK, payload: { hostingId } });
const getAddonCheckSuccess = data => ({ type: SitesActionTypes.GET_ADDON_CHECK_SUCCESS, payload: data });
const getAddonCheckFailure = () => ({ type: SitesActionTypes.GET_ADDON_CHECK_FAILURE });
const setAddonCheckDefault = () => ({ type: SitesActionTypes.SET_ADDON_CHECK_DEFAULT });

// VERIFY IF SITE EXIST
const requestVerifyIfSiteExist = ({ hostingId, domain }) => ({ type: SitesActionTypes.REQUEST_VERIFY_SITE_EXIST, payload: { hostingId, domain } });
const requestVerifyIfSiteExistSuccess = data => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_SUCCESS, payload: data });
const requestVerifyIfSiteExistLoading = isLoading => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_LOADING, payload: { isLoading } });
const requestVerifyIfSiteExistFailure = () => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_FAILURE });
const requestVerifyIfSiteExistReset = () => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_RESET });
const requestVerifyIfSiteExistDefaultFilesExclude = data => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE, payload: data });
const requestVerifyIfSiteExistDefaultFilesExcludeSuccess = () => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE_SUCCESS });
const requestVerifyIfSiteExistDefaultFilesExcludeFailure = () => ({ type: SitesActionTypes.GET_VERIFY_SITE_EXIST_DEFAULT_FILES_EXCLUDE_FAILURE });

// UNINSTALL SITE
const requestUninstallSite = ({
  hostingId, domain, domainId, domainHasPlan, needToExcludeDefaultFiles, onSuccess,
}) => ({
  type: SitesActionTypes.REQUEST_UNINSTALL_SITE,
  payload: {
    hostingId, domain, domainId, domainHasPlan, needToExcludeDefaultFiles, onSuccess,
  },
});
const uninstallSiteSuccess = () => ({ type: SitesActionTypes.UNINSTALL_SITE_SUCCESS });
const uninstallSiteLoading = isLoading => ({ type: SitesActionTypes.UNINSTALL_SITE_LOADING, payload: { isLoading } });
const uninstallSiteFailure = () => ({ type: SitesActionTypes.UNINSTALL_SITE_FAILURE });

// DOMAIN DNS STATUS CHECK
const requestDomainDnsStatusCheck = ({ domain }) => ({ type: SitesActionTypes.REQUEST_DOMAIN_DNS_STATUS_CHECK, payload: { domain } });
const domainDnsStatusCheckSuccess = data => ({ type: SitesActionTypes.GET_DOMAIN_DNS_STATUS_CHECK_SUCCESS, payload: data });
const domainDnsStatusCheckFailure = () => ({ type: SitesActionTypes.GET_DOMAIN_DNS_STATUS_CHECK_FAILURE });

// DOMAIN DNS STATUS CHECK
const requestAllDomainsDnsStatusCheck = () => ({ type: SitesActionTypes.REQUEST_ALL_DOMAINS_DNS_STATUS_CHECK });
const domainsDnsStatusCheckSuccess = data => ({ type: SitesActionTypes.GET_ALL_DOMAINS_DNS_STATUS_CHECK_SUCCESS, payload: data });
const domainsDnsStatusCheckFailure = () => ({ type: SitesActionTypes.GET_ALL_DOMAINS_DNS_STATUS_CHECK_FAILURE });
const requestDomainsDnsStatusLoading = isLoading => ({ type: SitesActionTypes.GET_ALL_DOMAINS_DNS_STATUS_CHECK_LOADING, payload: { isLoading } });

const redirectFromPreChat = bool => ({ type: SitesActionTypes.SITES_FROM_PRECHAT, payload: bool });

// SSL
const clearSSLStatus = () => ({ type: SitesActionTypes.CLEAR_SSL_STATUS });

const requestAutoSSLStart = ({ domain, hostingId }) => ({ type: SitesActionTypes.AUTO_SSL_START_REQUEST, payload: { domain, hostingId } });
const successAutoSSLStart = () => ({ type: SitesActionTypes.AUTO_SSL_START_SUCCESS });
const failureAutoSSLStart = () => ({ type: SitesActionTypes.AUTO_SSL_START_FAILURE });

const requestAutoSSLProgress = ({ domain, hostingId }) => ({ type: SitesActionTypes.AUTO_SSL_PROGRESS_REQUEST, payload: { domain, hostingId } });
const loopAutoSSLProgress = ({ callLoop }) => ({ type: SitesActionTypes.AUTO_SSL_PROGRESS_LOOP, payload: { callLoop } });
const failureAutoSSLProgress = () => ({ type: SitesActionTypes.AUTO_SSL_PROGRESS_FAILURE });

const requestAutoSSLCheck = ({ hostingId, domain }) => ({ type: SitesActionTypes.AUTO_SSL_CHECK_REQUEST, payload: { hostingId, domain } });
const successAutoSSLCheck = () => ({ type: SitesActionTypes.AUTO_SSL_CHECK_SUCCESS });
const failureAutoSSLCheck = () => ({ type: SitesActionTypes.AUTO_SSL_CHECK_FAILURE });

const requestSslVerification = ({ domain, hostingId }) => ({ type: SitesActionTypes.SSL_VERIFICATION_REQUEST, payload: { domain, hostingId } });
const setSslVerification = data => ({ type: SitesActionTypes.SET_SSL_VERIFICATION, payload: data });

const postDomainToHgPlan = ({ domain }) => ({ type: SitesActionTypes.REQUEST_POST_DOMAIN_TO_HG, payload: { domain } });
const successPostDomainToHgPlan = () => ({ type: SitesActionTypes.POST_DOMAIN_TO_HG_SUCCESS });
const failurePostDomainToHgPlan = () => ({ type: SitesActionTypes.POST_DOMAIN_TO_HG_FAILURE });

const requestGatorResolveForms = data => ({ type: SitesActionTypes.REQUEST_GATOR_RESOLVE_FORM, payload: data });
const loadingGatorResolveForms = isLoading => ({ type: SitesActionTypes.LOADING_GATOR_RESOLVE_FORM, payload: isLoading });
const resetGatorResolveForms = () => ({ type: SitesActionTypes.RESET_GATOR_RESOLVE_FORM });
const successGatorResolveForms = data => ({ type: SitesActionTypes.SUCCESS_GATOR_RESOLVE_FORM, payload: data });
const failureGatorResolveForms = () => ({ type: SitesActionTypes.FAILURE_GATOR_RESOLVE_FORM });

const requestRdCreateLead = data => ({ type: SitesActionTypes.RD_CREATE_LEAD_REQUEST, payload: data });

const createSiteWithBuilderRequest = ({
  builderAddonId, domain, type, projectData = null, templateId = null, popupBlockedAction, isAgentFactory, aiBuilderAgentData = null,
}) => ({
  type: SitesActionTypes.CREATE_SITE_WITH_BUILDER_REQUEST,
  payload: {
    builderAddonId, domain, type, projectData, templateId, popupBlockedAction, isAgentFactory, aiBuilderAgentData,
  },
});

/* Novo Builder */
const setCreateSiteWithBuilder = ({ builderAddonId, domain, url }) => ({ type: SitesActionTypes.SET_CREATE_SITE_WITH_BUILDER, payload: { builderAddonId, domain, url } });
const resetCreateSiteWithBuilder = () => ({ type: SitesActionTypes.RESET_CREATE_SITE_WITH_BUILDER });
const createSiteWithBuilderFailure = () => ({ type: SitesActionTypes.CREATE_SITE_WITH_BUILDER_FAILURE });
const setCreateSiteWithBuilderLoading = isLoading => ({
  type: SitesActionTypes.SET_CREATE_SITE_WITH_BUILDER_LOADING,
  payload: { isLoading },
});

const createPreviewWithBuilderRequest = ({
  type, projectData = null,
}) => ({
  type: SitesActionTypes.CREATE_PREVIEW_WITH_BUILDER_REQUEST,
  payload: {
    type, projectData,
  },
});
const setCreatePreviewWithBuilder = ({ projectUid }) => ({ type: SitesActionTypes.SET_CREATE_PREVIEW_WITH_BUILDER, payload: { projectUid } });
const createPreviewWithBuilderFailure = () => ({ type: SitesActionTypes.CREATE_PREVIEW_WITH_BUILDER_FAILURE });
const resetCreatePreviewWithBuilder = () => ({ type: SitesActionTypes.RESET_CREATE_PREVIEW_WITH_BUILDER });
const setCreatePreviewWithBuilderLoading = isLoading => ({
  type: SitesActionTypes.SET_CREATE_PREVIEW_WITH_BUILDER_LOADING,
  payload: { isLoading },
});

const syncPreviewWithBuilderRequest = ({
  builderAddonId, domain, popupBlockedAction, isAgentFactory, aiBuilderAgentData = null,
}) => ({
  type: SitesActionTypes.SYNC_PREVIEW_WITH_BUILDER_REQUEST,
  payload: {
    builderAddonId, domain, popupBlockedAction, isAgentFactory, aiBuilderAgentData,
  },
});

const setSyncPreviewWithBuilder = ({ url }) => ({ type: SitesActionTypes.SET_SYNC_PREVIEW_WITH_BUILDER, payload: { url } });
const syncPreviewWithBuilderFailure = () => ({ type: SitesActionTypes.SYNC_PREVIEW_WITH_BUILDER_FAILURE });
const setSyncPreviewWithBuilderLoading = isLoading => ({
  type: SitesActionTypes.SET_SYNC_PREVIEW_WITH_BUILDER_LOADING,
  payload: { isLoading },
});

const requestBuilderSSO = ({
  builderAddonId, domain, callback, popupBlockedAction,
}) => ({
  type: SitesActionTypes.REQUEST_BUILDER_SSO,
  payload: {
    builderAddonId, domain, callback, popupBlockedAction,
  },
});

const setBuilderSSO = ({
  builderAddonId,
  domain,
  url,
}) => ({
  type: SitesActionTypes.SET_BUILDER_SSO,
  payload: {
    builderAddonId,
    domain,
    url,
  },
});

const successBuilderSSO = () => ({
  type: SitesActionTypes.SET_BUILDER_SSO_SUCCESS,
});

const failureBuilderSSO = () => ({ type: SitesActionTypes.SET_BUILDER_SSO_FAILURE });
const setBuilderSSOLoading = isLoading => ({
  type: SitesActionTypes.SET_BUILDER_SSO_LOADING,
  payload: { isLoading },
});

const agentsFactoryAccountRequest = payload => ({ type: SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_REQUEST, payload });
const agentsFactoryAccountSuccess = () => ({ type: SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_SUCCESS });
const agentsFactoryAccountFailure = () => ({ type: SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_FAILURE });
const agentsFactoryAccountSet = payload => ({ type: SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_SET, payload });
const agentsFactoryLoading = isLoading => ({ type: SitesActionTypes.AGENTS_FACTORY_CHECK_AVAILABILITY_LOADING, payload: isLoading });

const createBusinessProfileRequest = data => ({ type: SitesActionTypes.CREATE_BUSINESS_PROFILE_REQUEST, payload: data });
const createBusinessProfileSuccess = () => ({ type: SitesActionTypes.CREATE_BUSINESS_PROFILE_SUCCESS });
const createBusinessProfileFailure = () => ({ type: SitesActionTypes.CREATE_BUSINESS_PROFILE_FAILURE });
const createBusinessProfileLoading = isLoading => ({ type: SitesActionTypes.CREATE_BUSINESS_PROFILE_LOADING, payload: isLoading });

const triggerSiteCreatedWithTempDomain = data => ({
  type: SitesActionTypes.TRIGGER_SITE_CREATED_WITH_TEMP_DOMAIN,
  payload: data,
});

const requestDomainsWithSites = () => ({ type: SitesActionTypes.GET_DOMAINS_WITH_AI_SITES_CREATED });
const loadingDomainsWithSites = isLoading => ({ type: SitesActionTypes.LOADING_DOMAINS_WITH_AI_SITES_CREATED, payload: isLoading });
const successRequestDomainsWithSites = data => ({ type: SitesActionTypes.GET_DOMAINS_WITH_AI_SITES_CREATED_SUCCESS, payload: data });
const failRequestDomainsWithSites = () => ({ type: SitesActionTypes.GET_DOMAINS_WITH_AI_SITES_CREATED_FAILURE });
const setDomainsWithSitesCreated = data => ({ type: SitesActionTypes.SET_DOMAINS_WITH_AI_SITES_CREATED, payload: data });

const actions = {
  loading: {
    set: setLoading,
  },
  loadingExclusion: {
    set: setLoadingExclusion,
  },
  loadingTlds: {
    set: setLoadingTlds,
  },
  loadingDomains: {
    set: setLoadingDomains,
  },
  loadingPlans: {
    set: setLoadingPlans,
  },
  loadingSites: {
    set: setLoadingSites,
  },
  loadingDomainValidation: {
    set: setLoadingDomainValidation,
  },
  sites: {
    failure: getSitesFailure,
    request: requestSites,
    success: getSitesSuccess,
    set: setSites,
  },
  site: {
    delete: deleteSite,
    loadRedirect,
    redirectToEdit,
  },
  gatorResolve: {
    request: requestGatorResolveForms,
    success: successGatorResolveForms,
    failure: failureGatorResolveForms,
    loading: loadingGatorResolveForms,
    reset: resetGatorResolveForms,
  },
  domains: {
    failure: getDomainsFailure,
    request: requestDomains,
    success: getDomainsSuccess,
    set: setDomains,
    requestDomainsWithSites,
    loadingDomainsWithSites,
    successRequestDomainsWithSites,
    failRequestDomainsWithSites,
    setDomainsWithSitesCreated,
  },
  domainBuilderTools: {
    request: requestSiteBuilderTools,
    set: setSiteBuilderTools,
    loading: loadSiteBuilderTools,
    get: getSiteBuilderTools,
  },
  tlds: {
    failure: getTldsFailure,
    request: requestTlds,
    success: getTldsSuccess,
    set: setTlds,
  },
  domainAvailability: {
    failure: getDomainAvailabilityFailure,
    request: requestDomainAvailability,
    success: getDomainAvailabilitySuccess,
    set: setDomainAvailability,
  },
  plans: {
    request: requestPlans,
    success: getPlansSuccess,
    failure: getPlansFailure,
    set: setPlans,
  },
  warnings: {
    success: setWarningsSuccess,
    failure: setWarningsFailure,
    set: setWarningSeen,
  },
  aditionalDomain: {
    request: requestAditionalDomain,
    success: succeedRequestAditionalDomain,
    failure: failRequestAditionalDomain,
    set: setAditionalDomainLinkedToPlan,
  },
  changeDomainDns: {
    request: requestChangeDomainDns,
    set: setDomainDnsChanged,
    success: changeDomainDnsSuccess,
    failure: changeDomainDnsFailure,
  },
  domainDns: {
    request: requestDomainDns,
    success: domainDnsSuccess,
    failure: domainDnsFailure,
    loading: domainDnsLoading,
    resetStatus: resetDomainDnsStatus,
    set: setDomainDns,
  },
  planDns: {
    request: requestPlanDns,
    success: planDnsSuccess,
    failure: planDnsFailure,
    loading: setPlanDnsLoading,
    reset: resetPlanDns,
    set: setPlanDns,
  },
  wordpressInstallation: {
    request: requestWordpressInstallation,
    success: setWordpressInstallationSuccess,
    failure: setWordpressInstallationFailure,
    set: setWordpressInstallationLoading,
    setStatus: setWordpressInstallationStatus,
    reset: setWordpressInstallationToDefault,
  },
  wordpressFtpMigration: {
    request: requestWordpressFtpMigration,
    success: setWordpressFtpMigrationSuccess,
    failure: setWordpressFtpMigrationFailure,
    loading: setWordpressFtpMigrationLoading,
    reset: setWordpressFtpMigrationReset,
  },
  wordpressFileMigration: {
    requestData: requestwordpressFilesData,
    successfullyRequestedData,
    failureRequestedData,
    request: requestWordpressFilesMigration,
    successfullyRequestedMigration,
    failureRequestedMigration,
    loading: setWordpressFilesMigrationLoading,
    install: wordpressInstallFiles,
    finishedRequestedInstallation,
    failureRequestedInstallation,
  },
  wordpressSso: {
    request: requestWordpressSSO,
    success: successWordpressSSO,
    failure: failureWordpressSSO,
    set: setWordpressSSO,
    loading: setWordpressSSOLoading,
  },
  surveyQuestionsAnswered: {
    request: requestSurveyQuestionsAnswered,
    success: surveyQuestionsAnsweredSuccess,
    failure: surveyQuestionsAnsweredFailure,
    set: setSurveyQuestionsAnswered,
  },
  hasSiteBuilderActive: {
    set: setHasSiteBuilderActive,
  },
  force: {
    reload: forceReload,
  },
  addonCheck: {
    request: requestAddonCheck,
    success: getAddonCheckSuccess,
    failure: getAddonCheckFailure,
    reset: setAddonCheckDefault,
  },
  chat: {
    setRedirectFromPreChat: redirectFromPreChat,
  },
  verifyIfSiteExist: {
    request: requestVerifyIfSiteExist,
    success: requestVerifyIfSiteExistSuccess,
    failure: requestVerifyIfSiteExistFailure,
    loading: requestVerifyIfSiteExistLoading,
    reset: requestVerifyIfSiteExistReset,
    defaultFilesExclude: {
      request: requestVerifyIfSiteExistDefaultFilesExclude,
      success: requestVerifyIfSiteExistDefaultFilesExcludeSuccess,
      failure: requestVerifyIfSiteExistDefaultFilesExcludeFailure,
    },
  },
  uninstallSite: {
    request: requestUninstallSite,
    success: uninstallSiteSuccess,
    failure: uninstallSiteFailure,
    loading: uninstallSiteLoading,
  },
  domainDnsStatusCheck: {
    request: requestDomainDnsStatusCheck,
    success: domainDnsStatusCheckSuccess,
    failure: domainDnsStatusCheckFailure,
  },
  allDomainsDnsStatusCheck: {
    request: requestAllDomainsDnsStatusCheck,
    success: domainsDnsStatusCheckSuccess,
    failure: domainsDnsStatusCheckFailure,
    loading: requestDomainsDnsStatusLoading,
  },
  ssl: {
    clearStatus: clearSSLStatus,
    start: {
      request: requestAutoSSLStart,
      success: successAutoSSLStart,
      failure: failureAutoSSLStart,
    },
    progress: {
      request: requestAutoSSLProgress,
      loop: loopAutoSSLProgress,
      failure: failureAutoSSLProgress,
    },
    check: {
      request: requestAutoSSLCheck,
      success: successAutoSSLCheck,
      failure: failureAutoSSLCheck,
    },
    verification: {
      request: requestSslVerification,
      set: setSslVerification,
      loading: setLoadingSslVerification,
    },
    pointDomain: {
      request: postDomainToHgPlan,
      success: successPostDomainToHgPlan,
      failure: failurePostDomainToHgPlan,
      loading: setLoadingSslDomainConfiguration,
    },
  },
  rdStation: {
    request: requestRdCreateLead,
  },
  sitebuilder: {
    createSite: {
      request: createSiteWithBuilderRequest,
      set: setCreateSiteWithBuilder,
      failure: createSiteWithBuilderFailure,
      setLoading: setCreateSiteWithBuilderLoading,
      reset: resetCreateSiteWithBuilder,
    },
    createPreview: {
      request: createPreviewWithBuilderRequest,
      set: setCreatePreviewWithBuilder,
      failure: createPreviewWithBuilderFailure,
      setLoading: setCreatePreviewWithBuilderLoading,
      reset: resetCreatePreviewWithBuilder,
    },
    syncPreview: {
      request: syncPreviewWithBuilderRequest,
      set: setSyncPreviewWithBuilder,
      failure: syncPreviewWithBuilderFailure,
      setLoading: setSyncPreviewWithBuilderLoading,
    },
  },
  builderSso: {
    request: requestBuilderSSO,
    set: setBuilderSSO,
    success: successBuilderSSO,
    failure: failureBuilderSSO,
    loading: setBuilderSSOLoading,
  },
  agentsFactory: {
    loading: agentsFactoryLoading,
    account: {
      request: agentsFactoryAccountRequest,
      success: agentsFactoryAccountSuccess,
      failure: agentsFactoryAccountFailure,
      set: agentsFactoryAccountSet,
    },
  },
  businessProfile: {
    request: createBusinessProfileRequest,
    success: createBusinessProfileSuccess,
    failure: createBusinessProfileFailure,
    loading: createBusinessProfileLoading,
  },
  trigger: {
    siteCreatedWithTempDomain: triggerSiteCreatedWithTempDomain,
  },
};

export default actions;
